import {Component, ElementRef, ViewChild} from '@angular/core';
import {Nav, NavController, Platform} from 'ionic-angular';
import {LoginProvider} from "../providers/login/login";
import {ScreenOrientation} from "@ionic-native/screen-orientation";
import {TranslateService} from "@ngx-translate/core";
import {OneSignal} from '@ionic-native/onesignal';
import {environment} from '../environment';
import {BehaviorSubject, Subscription} from 'rxjs';
import {first, skipWhile} from 'rxjs/operators';

import { timer } from 'rxjs/observable/timer';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any;
  @ViewChild(Nav) navChild: NavController;
  @ViewChild('nav') nav: ElementRef;

  /**
   * Le avisa a las notificaciones cuando la app está lista para manejar el cambio de página
   * @private
   */
  private appLista: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private pendienteManejoDeNotificacionSubscription: Subscription = null;

  showSplash = true;

constructor(platform: Platform,
              translateService: TranslateService,
              _loginProvider: LoginProvider,
              orientation: ScreenOrientation,
              private oneSignal: OneSignal,
  ) {
    platform.ready().then(() => {
      this.showSplash = false;
      var navHTML = this.nav.nativeElement;
      // navHTML.style.visibility = "hidden";
      
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      timer(5200).subscribe(()=>{
        this.showSplash = false;
        navHTML.style.visibility = "visible";
      });
      if (platform.is('cordova')) {
        orientation.lock(orientation.ORIENTATIONS.PORTRAIT).catch(res => res);
        this.inicializarOneSignal();
      }
      translateService.setDefaultLang('es');
      translateService.use('es');
      this.navChild.viewDidEnter.pipe(first()).subscribe(() => {
        this.appLista.next(true);
      });
      _loginProvider.loadTokenFromStorage().then((val) => {
        if (val){
          this.rootPage = 'LogPage';
        }
        else{
          this.rootPage = 'LogPage';
        }
      })
    });
  }


  inicializarOneSignal() {
    const iosSettings = {
      kOSSettingsKeyAutoPrompt: true,
      kOSSettingsKeyInAppLaunchURL: false,
    };

    this.oneSignal.startInit(environment.oneSignalAppId);
    this.oneSignal.iOSSettings(iosSettings);
    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);
    this.oneSignal.handleNotificationOpened().subscribe((data) => {
      if (!data) {
        return;
      }
      const datosAdicionales = data.notification.payload.additionalData;
      const itemId = datosAdicionales.id;
      const tipoNotificacion = datosAdicionales.tipo;

      this.manejarNotificacion(tipoNotificacion, itemId);
    });
    this.oneSignal.endInit();
  }

  /**
   * Se encarga de manejar la notificación solamente cuando la app esté lista
   *
   * @param tipoNotificacion
   * @param itemId
   * @private
   */
  private manejarNotificacion(tipoNotificacion, itemId) {
    if (this.pendienteManejoDeNotificacionSubscription !== null) {
      this.pendienteManejoDeNotificacionSubscription.unsubscribe();
      this.pendienteManejoDeNotificacionSubscription = null;
    }
    this.pendienteManejoDeNotificacionSubscription = this.appLista.pipe(
      skipWhile(appLista => !appLista),
    ).subscribe((appLista) => {
      if (!appLista) {
        return;
      }
      switch (tipoNotificacion) {
        case "Nota":
          this.navChild.push('NotaDetallesPage', {id: itemId}).then();
          break;
        case "Promoción":
          this.navChild.push('DetallesPromocionPage', {id: itemId}).then();
          break;
        case "Evento":
          this.navChild.push('DetallesEventoPage', {id: itemId}).then();
          break;
        case "Testimonio":
          this.navChild.push('DetalleComunidadPage', {idTestimonio: itemId}).then();
          break;
      }
      if (this.pendienteManejoDeNotificacionSubscription !== null) {
        this.pendienteManejoDeNotificacionSubscription.unsubscribe();
        this.pendienteManejoDeNotificacionSubscription = null;
      }
    });
  }
  initializeApp(){
    
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts